// extracted by mini-css-extract-plugin
export default {"cardContainer":"sessionNew_cardContainer__Em6Zu","showCard":"sessionNew_showCard__Waxho","editStyle":"sessionNew_editStyle__5oK8r","font20":"sessionNew_font20__xSiEz"};